import lookup from "country-code-lookup";

function countryToIsoCode(countryName) {
  if (countryName) {
    const countryCode = lookup.byCountry(countryName);
    if (countryCode) {
      return countryCode.iso2;
    }
    return null;
  }
  return null;
}

export default countryToIsoCode;
